export const SubscriptionLandingPages: Record<string, string> = {
  events: '/products/events',
  invoice: '/products/advanced-invoicing',
  kds: '/products/kitchen-display-system',
  kiosk: '/products/kiosk',
};
